/**
 * EmptyDashboard Component
 *
 * Empty state shown on the dashboard when the organization has no canaries.
 * Reached after a user finishes the onboarding wizard but has not yet
 * created any canaries (e.g. they deleted their first one). The wizard's
 * DoneStep covers the "what's next" content for fresh signups, so this
 * screen stays focused on a single primary CTA.
 */

import { Link } from 'react-router-dom'
import { Button } from '@/components/ui'

type EmptyDashboardProps = {
  // Reserved for future "trial just activated" messaging.
  activatedAt?: string
}

export function EmptyDashboard(_props: EmptyDashboardProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
        <Link to="/canaries/new">
          <Button variant="primary">Create a Canary</Button>
        </Link>
      </div>

      <div className="bg-white shadow rounded-lg p-8 text-center">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-primary-100 mb-4">
          <svg
            className="h-8 w-8 text-primary-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
            />
          </svg>
        </div>
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Welcome back — no canaries yet
        </h2>
        <p className="text-gray-500 max-w-md mx-auto">
          You finished onboarding, but this organization doesn&apos;t have any
          canaries right now. Create one to start watching for unauthorized
          copies of your web pages.
        </p>
      </div>
    </div>
  )
}
